import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

import styles from './Table.module.scss';

const Table = ({ fields }) => {
	const { t } = useTranslation('contractGenerator');

	const convertToString = value => {
		if (typeof value === 'boolean') {
			if (value) {
				return t('app.yes');
			}
			return t('app.no');
		}

		if (typeof value === 'object') {
			return value.value;
		}

		return value;
	};

	return (
		<div className={styles.table}>
			{fields.map(field => (
				<FlexBox key={field.label} alignItems='flex-start' className={styles.tableRow}>
					<div className={styles.label}>{field.label}</div>
					<div className={styles.value}>{convertToString(field.value)}</div>
				</FlexBox>
			))}
		</div>
	);
};

Table.propTypes = {
	fields: PropTypes.array.isRequired
};

export default Table;
